import { get } from "axios";
import { apiBaseUrl } from "./baseURL";

const mockApiBaseUrl = '/mock/'
export const urls = Object.freeze({

  signIn: `${apiBaseUrl}login`,
  authenticate: `${apiBaseUrl}authenticate`,

  employeeMaster: `${mockApiBaseUrl}employeeMaster`,
  saveEmployeeMaster: `${mockApiBaseUrl}saveEmployeeMaster`,
  deleteEmployeeMaster: (id) => `${mockApiBaseUrl}deleteEmployeeMaster/${id}`,
  deleteSelectedEmployees: `${mockApiBaseUrl}employee-master/delete`,

  areaMaster: `${apiBaseUrl}area-list`,
  cityListByArea: `${apiBaseUrl}area-by-city`,
  saveAreaMaster: `${apiBaseUrl}area-store`,
  updateAreaMaster: `${apiBaseUrl}area-update`,
  deleteAreaMaster: (id) => `${apiBaseUrl}area-destroy/${id}`,
  getEditAreaMaster: (id) => `${apiBaseUrl}area-show/${id}`,

  allowanceMaster: `${apiBaseUrl}daily-allowance-cost-list`,
  saveAllowanceMaster: `${apiBaseUrl}daily-allowance-cost-store`,
  updateAllowanceMaster: `${apiBaseUrl}daily-allowance-cost-update`,
  deleteAllowanceMaster: (id) => `${apiBaseUrl}daily-allowance-cost-destroy/${id}`,
  getEditAllowanceMaster: (id) => `${apiBaseUrl}daily-allowance-cost-show/${id}`,

  bankMaster: `${apiBaseUrl}bank-list`,
  saveBankMaster: `${apiBaseUrl}bank-store`,
  updateBankMaster: `${apiBaseUrl}bank-update`,
  deleteBankMaster: (id) => `${apiBaseUrl}bank-destroy/${id}`,
  getEditBankMaster: (id) => `${apiBaseUrl}bank-show/${id}`,

  brandMaster: `${apiBaseUrl}brand-list`,
  saveBrandMaster: `${apiBaseUrl}brand-store`,
  updateBrandMaster: `${apiBaseUrl}brand-update`,
  deleteBrandMaster: (id) => `${apiBaseUrl}brand-destroy/${id}`,
  getEditBrandMaster: (id) => `${apiBaseUrl}brand-show/${id}`,

  categoryMaster: `${apiBaseUrl}category-list`,
  categoryListByBrand: (id) => `${apiBaseUrl}category-by-brand/${id}`,
  saveCategoryMaster: `${apiBaseUrl}category-store`,
  updateCategoryMaster: `${apiBaseUrl}category-update`,
  deleteCategoryMaster: (id) => `${apiBaseUrl}category-destroy/${id}`,
  getEditCategoryMaster: (id) => `${apiBaseUrl}category-show/${id}`,

  cityMaster: `${apiBaseUrl}city-list`,
  cityListByDistrict: `${apiBaseUrl}city-by-district`,
  saveCityMaster: `${apiBaseUrl}city-store`,
  updateCityMaster: `${apiBaseUrl}city-update`,
  deleteCityMaster: (id) => `${apiBaseUrl}city-destroy/${id}`,
  getEditCityMaster: (id) => `${apiBaseUrl}city-show/${id}`,

  regularClaimRMList: `${apiBaseUrl}claims-reporting-manager`,
  regularClaimDMList: `${apiBaseUrl}claims-regular-gm-list`,
  regularClaimHRList: `${apiBaseUrl}claims-regular-hr-list`,
  regularClaimExeList: `${apiBaseUrl}claims-regular-acc-executive-list`,
  regularClaimAccList: `${apiBaseUrl}claims-regular-acc-manager-list`,

  claimBackofficeList: `${apiBaseUrl}claim-backoffice-list`,
  claimExecutiveList: `${apiBaseUrl}claim-executive-list`,
  claimManagerList: `${apiBaseUrl}claims-multiple`,
  claimManagerListMain: `${apiBaseUrl}claim-general-manager-list`,
  claimHrListMain: `${apiBaseUrl}claim-manager-list`,
  getClaimBackofficeList: (id) => `${apiBaseUrl}claim-details/${id}`,
  getClaimDetailsList: `${apiBaseUrl}claim-details-list`,
  approveClaimIfoods: `${apiBaseUrl}claim-approval`,
  approveClaimBackoffice: `${apiBaseUrl}claim-approval-backoffice`,
  approveClaimRegular: `${apiBaseUrl}claims-regular-approval`,
  rejectRegularClaim: `${apiBaseUrl}user-claim-detail-remove`,

  verifyClaim: `${apiBaseUrl}claims-verify`,
  rejectClaimIfoods: `${apiBaseUrl}claim-approval`,
  saveClaimMaster: `${apiBaseUrl}add-claim`,
  updateClaimMaster: `${apiBaseUrl}update-claim`,
  claimReport: `${apiBaseUrl}claim-report`,
  expenseDetailsShow: `${apiBaseUrl}expense-details-show-multiple`,
  visitInfoDetails: `${apiBaseUrl}visit-info-details`,
  claimExpenseReport: `${apiBaseUrl}claim-expense-report`,
  claimApprovedAmtUpdate: `${apiBaseUrl}claims-update-approved-amounts`,
  claimUpdatePercentage: `${apiBaseUrl}claim-update-percentage`,

  companyMaster: `${apiBaseUrl}company-list`,
  saveCompanyMaster: `${apiBaseUrl}company-store`,
  updateCompanyMaster: `${apiBaseUrl}company-update`,
  deleteCompanyMaster: (id) => `${apiBaseUrl}company-destroy/${id}`,
  getEditCompanyMaster: (id) => `${apiBaseUrl}company-show/${id}`,

  competitorMaster: `${apiBaseUrl}competitor-list`,
  saveCompetitorMaster: `${apiBaseUrl}competitor-store`,
  updateCompetitorMaster: `${apiBaseUrl}competitor-update`,
  deleteCompetitorMaster: (id) => `${apiBaseUrl}competitor-destroy/${id}`,
  getEditCompetitorMaster: (id) => `${apiBaseUrl}competitor-show/${id}`,

  competitorOffers: `${apiBaseUrl}comp-prod-offers-list`,
  saveCompetitorOffers: `${apiBaseUrl}comp-prod-offers-store`,
  updateCompetitorOffers: `${apiBaseUrl}comp-prod-offers-update`,
  deleteCompetitorOffers: (id) => `${apiBaseUrl}comp-prod-offers-destroy/${id}`,
  getEditCompetitorOffers: (id) => `${apiBaseUrl}comp-prod-offers-show/${id}`,

  countryMaster: `${apiBaseUrl}country-list`,
  saveCountryMaster: `${apiBaseUrl}country-store`,
  updateCountryMaster: `${apiBaseUrl}country-update`,
  deleteCountryMaster: (id) => `${apiBaseUrl}country-destroy/${id}`,
  getEditCountryMaster: (id) => `${apiBaseUrl}country-show/${id}`,

  departmentMaster: `${apiBaseUrl}department-list`,
  departmentList: `${apiBaseUrl}department-by-division`,
  saveDepartmentMaster: `${apiBaseUrl}department-store`,
  updateDepartmentMaster: `${apiBaseUrl}department-update`,
  deleteDepartmentMaster: (id) => `${apiBaseUrl}department-destroy/${id}`,
  getEditDepartmentMaster: (id) => `${apiBaseUrl}department-show/${id}`,

  designationMaster: `${apiBaseUrl}designation-list`,
  designationList: `${apiBaseUrl}designation-by-department`,
  saveDesignationMaster: `${apiBaseUrl}designation-store`,
  updateDesignationMaster: `${apiBaseUrl}designation-update`,
  deleteDesignationMaster: (id) => `${apiBaseUrl}designation-destroy/${id}`,
  getEditDesignationMaster: (id) => `${apiBaseUrl}designation-show/${id}`,

  districtMaster: `${apiBaseUrl}district-list`,
  districtListByState: `${apiBaseUrl}district-by-state`,
  districtListByUser: `${apiBaseUrl}user-venue-district-list`,
  districtListBySubzone: `${apiBaseUrl}district-by-subzone`,
  saveDistrictMaster: `${apiBaseUrl}district-store`,
  updateDistrictMaster: `${apiBaseUrl}district-update`,
  getEditDistrictMaster: (id) => `${apiBaseUrl}district-show/${id}`,
  deleteDistrictMaster: (id) => `${apiBaseUrl}district-destroy/${id}`,

  divisionMaster: `${apiBaseUrl}division-list`,
  saveDivisionMaster: `${apiBaseUrl}division-store`,
  updateDivisionMaster: `${apiBaseUrl}division-update`,
  deleteDivisionMaster: (id) => `${apiBaseUrl}division-destroy/${id}`,
  getEditDivisionMaster: (id) => `${apiBaseUrl}division-show/${id}`,

  dropdownMaster: `${apiBaseUrl}dropdown-list`,
  saveDropdownMaster: `${apiBaseUrl}dropdown-store`,
  updateDropdownMaster: `${apiBaseUrl}dropdown-update`,
  deleteDropdownMaster: (id) => `${apiBaseUrl}dropdown-destroy/${id}`,
  getEditDropdownMaster: (id) => `${apiBaseUrl}dropdown-show/${id}`,
  dropdownListByDropdown: (id) => `${apiBaseUrl}dropdownlistsByDropdown/${id}`,

  dropdownlistMaster: `${apiBaseUrl}dropdownlist-list`,
  saveDropdownlistMaster: `${apiBaseUrl}dropdownlist-store`,
  updateDropdownlistMaster: `${apiBaseUrl}dropdownlist-update`,
  deleteDropdownlistMaster: (id) => `${apiBaseUrl}dropdownlist-destroy/${id}`,
  getEditDropdownlistMaster: (id) => `${apiBaseUrl}dropdownlist-show/${id}`,

  expenseCategory: `${apiBaseUrl}expense-category-ddlist`,
  expenseType: (id) => `${apiBaseUrl}expense-type-ddlist/${id}`,
  cityType: (cid, tid) => `${apiBaseUrl}city-type-ddlist/${cid}/${tid}`,
  stayType: (cid, tid) => `${apiBaseUrl}lodging-stay-type-ddlist/${cid}/${tid}`,

  energypriceMaster: `${apiBaseUrl}vh-energy-price-list`,
  saveEnergyPriceMaster: `${apiBaseUrl}vh-energy-price-store`,
  updateEnergyPriceMaster: `${apiBaseUrl}vh-energy-price-update`,
  deleteEnergyPriceMaster: (id) => `${apiBaseUrl}vh-energy-price-destroy/${id}`,
  getEditEnergyPriceMaster: (id) => `${apiBaseUrl}vh-energy-price-show/${id}`,

  energytypeMaster: `${apiBaseUrl}vh-energy-type-list`,
  saveEnergyTypeMaster: `${apiBaseUrl}vh-energy-type-store`,
  updateEnergyTypeMaster: `${apiBaseUrl}vh-energy-type-update`,
  deleteEnergyTypeMaster: (id) => `${apiBaseUrl}vh-energy-type-destroy/${id}`,
  getEditEnergyTypeMaster: (id) => `${apiBaseUrl}vh-energy-type-show/${id}`,

  accommodationMaster: `${apiBaseUrl}accommodation-cost-list`,
  saveAccommodationMaster: `${apiBaseUrl}accommodation-cost-update`,
  updateAccommodationMaster: `${apiBaseUrl}accommodation-cost-update`,
  deleteAccommodationMaster: (id) => `${apiBaseUrl}accommodation-cost-destroy/${id}`,
  getEditAccommodationMaster: (id) => `${apiBaseUrl}accommodation-cost-show/${id}`,

  gradeMaster: `${apiBaseUrl}grade-list`,
  gradeMasterOption: `${apiBaseUrl}grade-by-designation`,
  saveGradeMaster: `${apiBaseUrl}grade-store`,
  updateGradeMaster: `${apiBaseUrl}grade-update`,
  deleteGradeMaster: (id) => `${apiBaseUrl}grade-destroy/${id}`,
  getEditGradeMaster: (id) => `${apiBaseUrl}grade-show/${id}`,

  approvalDesignation: `${apiBaseUrl}status-designation`,

  gradeList: `${apiBaseUrl}gradelist-list`,
  gradeListOption: `${apiBaseUrl}grade-list-by-grade`,
  saveGradeList: `${apiBaseUrl}gradelist-store`,
  updateGradeList: `${apiBaseUrl}gradelist-update`,
  deleteGradeList: (id) => `${apiBaseUrl}gradelist-destroy/${id}`,
  getEditGradeList: (id) => `${apiBaseUrl}gradelist-show/${id}`,

  materialMaster: `${apiBaseUrl}foods-material-list`,
  getMaterialDataFromSap: (id) => `${apiBaseUrl}sap-foods-material-creation/${id}`,
  saveMaterialMaster: `${apiBaseUrl}foods-material-store`,
  updateMaterialMaster: `${apiBaseUrl}foods-material-update`,
  materialDashboard: `${apiBaseUrl}foods-material-update`,
  deleteMaterialMaster: (id) => `${apiBaseUrl}foods-material-destroy/${id}`,
  getEditMaterialMaster: (id) => `${apiBaseUrl}foods-material-show/${id}`,

  menuMaster: `${apiBaseUrl}mainmenu-list`,
  saveMenuMaster: `${apiBaseUrl}mainmenu-store`,
  updateMenuMaster: `${apiBaseUrl}mainmenu-update`,
  deleteMenuMaster: (id) => `${apiBaseUrl}mainmenu-destroy/${id}`,
  getEditMenuMaster: (id) => `${apiBaseUrl}mainmenu-show/${id}`,

  menuList: `${apiBaseUrl}menulist-list`,
  menuListMaster: `${apiBaseUrl}menulist-by-menu`,
  saveMenuListMaster: `${apiBaseUrl}menulist-store`,
  updateMenuListMaster: `${apiBaseUrl}menulist-update`,
  deleteMenuListMaster: (id) => `${apiBaseUrl}menulist-destroy/${id}`,
  getEditMenuListMaster: (id) => `${apiBaseUrl}menulist-show/${id}`,

  menuAccess: `${apiBaseUrl}menuaccess-list`,
  saveMenuAccess: `${apiBaseUrl}menuaccess-store`,
  updateMenuAccess: `${apiBaseUrl}menuaccess-update`,
  deleteMenuAccess: (id) => `${apiBaseUrl}menuaccess-destroy/${id}`,
  getEditMenuAccess: (id) => `${apiBaseUrl}menuaccess-show/${id}`,

  outletMaster: `${apiBaseUrl}ifoodsoutlet-list`,
  outletBySubzone: `${apiBaseUrl}outlet-by-subzone`,
  saveOutletMaster: `${apiBaseUrl}ifoodsoutlet-store`,
  updateOutletMaster: `${apiBaseUrl}ifoodsoutlet-update`,
  deleteOutletMaster: (id) => `${apiBaseUrl}ifoodsoutlet-destroy/${id}`,
  getEditOutletMaster: (id) => `${apiBaseUrl}ifoodsoutlet-show/${id}`,

  plantMaster: `${apiBaseUrl}plant-list`,
  plantList: `${apiBaseUrl}plant-by-division`,
  savePlantMaster: `${apiBaseUrl}plant-store`,
  updatePlantMaster: `${apiBaseUrl}plant-update`,
  deletePlantMaster: (id) => `${apiBaseUrl}plant-destroy/${id}`,
  getEditPlantMaster: (id) => `${apiBaseUrl}plant-show/${id}`,

  productMaster: `${apiBaseUrl}product-list`,
  productListByCategory: (id) => `${apiBaseUrl}product-by-category/${id}`,
  saveProductMaster: `${apiBaseUrl}product-store`,
  updateProductMaster: `${apiBaseUrl}product-update`,
  deleteProductMaster: (id) => `${apiBaseUrl}product-destroy/${id}`,
  getEditProductMaster: (id) => `${apiBaseUrl}product-show/${id}`,

  prospectMaster: `${apiBaseUrl}ifoods-prospect-list`,
  saveProspectMaster: `${apiBaseUrl}ifoods-prospect-store`,
  prospectApproval: `${apiBaseUrl}ifoods-prospect-validation-approval`,
  updateProspectMaster: `${apiBaseUrl}ifoods-prospect-update`,
  pendingProspectMaster: `${apiBaseUrl}prospect-back-office-list`,
  deleteProspectMaster: (id) => `${apiBaseUrl}ifoods-prospect-destroy/${id}`,
  getEditProspectMaster: (id) => `${apiBaseUrl}ifoods-prospect-show/${id}`,
  prospectReport: `${apiBaseUrl}ifoods-prospect-report`,

  prospectValidation: `${apiBaseUrl}ifoods-prospect-list`,
  getEditProspectApprove: (id) => `${apiBaseUrl}ifoods-prospect-show/${id}`,

  stateMaster: `${apiBaseUrl}state-list`,
  stateList: `${apiBaseUrl}state-by-zone`,
  saveStateMaster: `${apiBaseUrl}state-store`,
  updateStateMaster: `${apiBaseUrl}state-update`,
  deleteStateMaster: (id) => `${apiBaseUrl}state-destroy/${id}`,
  getEditStateMaster: (id) => `${apiBaseUrl}state-show/${id}`,

  shiftMaster: `${apiBaseUrl}shift-list`,
  saveShiftMaster: `${apiBaseUrl}shift-store`,
  updateShiftMaster: `${apiBaseUrl}shift-update`,
  deleteShiftMaster: (id) => `${apiBaseUrl}shift-destroy/${id}`,
  getEditShiftMaster: (id) => `${apiBaseUrl}shift-show/${id}`,

  roleMaster: `${apiBaseUrl}role-list`,
  saveRoleMaster: `${apiBaseUrl}role-store`,
  updateRoleMaster: `${apiBaseUrl}role-update`,
  deleteRoleMaster: (id) => `${apiBaseUrl}role-destroy/${id}`,
  getEditRoleMaster: (id) => `${apiBaseUrl}role-show/${id}`,

  zoneMaster: `${apiBaseUrl}zone-list`,
  accessibleZoneMaster: `${apiBaseUrl}accessible-zones`,
  zoneByDivision: `${apiBaseUrl}zone-by-division`,
  saveZoneMaster: `${apiBaseUrl}zone-store`,
  updateZoneMaster: `${apiBaseUrl}zone-update`,
  deleteZoneMaster: (id) => `${apiBaseUrl}zone-destroy/${id}`,
  getEditZoneMaster: (id) => `${apiBaseUrl}zone-show/${id}`,

  subzoneMaster: `${apiBaseUrl}sub-zone-list`,
  subZoneList: `${apiBaseUrl}sub-zone-by-zone`,
  saveSubzoneMaster: `${apiBaseUrl}sub-zone-store`,
  updateSubzoneMaster: `${apiBaseUrl}sub-zone-update`,
  deleteSubzoneMaster: (id) => `${apiBaseUrl}sub-zone-destroy/${id}`,
  getEditSubzoneMaster: (id) => `${apiBaseUrl}sub-zone-show/${id}`,

  venueMaster: `${apiBaseUrl}venuemapping-list`,
  saveVenueMaster: `${apiBaseUrl}venuemapping-store`,
  updateVenueMaster: `${apiBaseUrl}venuemapping-update`,
  deleteVenueMaster: (id) => `${apiBaseUrl}sub-zone-destroy/${id}`,
  getEditVenueMaster: (id) => `${apiBaseUrl}venuemapping-show/${id}`,

  pjpStore: `${apiBaseUrl}foods-pjp-details-store`,
  pjpMaster: `${apiBaseUrl}foods-pjp-details`,
  pjpUpdate: `${apiBaseUrl}foods-pjp-details-update`,
  pjpDelete: (id) => `${apiBaseUrl}foods-pjp-details-destroy/${id}`,
  getEditPjpMaster: (id) => `${apiBaseUrl}foods-pjp-details-show/${id}`,

  primaryCustomer: `${apiBaseUrl}foods-primarycustomer-list`,
  primaryCustomerOption: `${apiBaseUrl}primarycustomer-id-name`,
  getPrimeCustDataFromSap: (id) => `${apiBaseUrl}sap-foods-primary-customer/${id}`,
  primeCustListBySubzone: `${apiBaseUrl}primarycustomer-by-subzone`,
  primeCustListByCity: `${apiBaseUrl}primarycustomer-by-city`,
  savePrimaryCustomerMaster: `${apiBaseUrl}foods-primarycustomer-store`,
  updatePrimaryCustomerMaster: `${apiBaseUrl}foods-primarycustomer-update`,
  deletePrimaryCustomerMaster: (id) => `${apiBaseUrl}foods-primarycustomer-destroy/${id}`,
  getEditPrimaryCustomerMaster: (id) => `${apiBaseUrl}foods-primarycustomer-show/${id}`,
  primaryCustomerReport: `${apiBaseUrl}primarycustomer-report`,

  primaryCustomerVisitReport: `${apiBaseUrl}customer-visit-report`,
  secondaryCustomerVisitReport: `${apiBaseUrl}secondary-customer-visit-report`,
  secondaryOrderReport: `${apiBaseUrl}secondary-order-details`,

  secondaryCustomerMaster: `${apiBaseUrl}foods-secondarycustomer-list`,
  saveSecCustomerMaster: `${apiBaseUrl}foods-secondarycustomer-store`,
  updateSecCustomerMaster: `${apiBaseUrl}foods-secondarycustomer-update`,
  deleteSecondaryCustomerMaster: (id) => `${apiBaseUrl}foods-secondarycustomer-destroy/${id}`,
  getEditSecCustomerMaster: (id) => `${apiBaseUrl}foods-secondarycustomer-show/${id}`,
  secondaryCustomerReport: `${apiBaseUrl}secondarycustomer-report`,

  userMaster: `${apiBaseUrl}user-list`,
  getVendorCode: `${apiBaseUrl}user-vendor-code-list`,
  crewMembers: `${apiBaseUrl}crew-member-user`,
  saveUserMaster: `${apiBaseUrl}register`,
  updateUserMaster: `${apiBaseUrl}user-update`,
  deleteUserMaster: (id) => `${apiBaseUrl}user-destroy/${id}`,
  resetUserAccess: `${apiBaseUrl}user-reset-access`,
  getEditUserMaster: (id) => `${apiBaseUrl}user-show/${id}`,
  getEditUserByDivision: `${apiBaseUrl}division-by-user`,
  getUserByMapDivision: `${apiBaseUrl}user-mapping-division`,

  saveUserImage: `${apiBaseUrl}file-upload`,
  deleteUserImage: `${apiBaseUrl}file-remove`,

  ifoodsPlanApproval: `${apiBaseUrl}plan-back-office-list`,
  getEditBoPlanApprove: (id) => `${apiBaseUrl}plan-details/${id}`,
  approvePlan: `${apiBaseUrl}approve-back-office`,
  rejectPlan: `${apiBaseUrl}reject-back-office`,
  approvePlanManager: `${apiBaseUrl}approve-first-level`,
  rejectPlanManager: `${apiBaseUrl}reject-first-level`,

  getPlanApprManager: (id) => `${apiBaseUrl}plan-approval-list/${id}`,

  getPlanDeviaApprManager: (id) => `${apiBaseUrl}deviation-approval-list/${id}`,
  deviationApprovalManager: `${apiBaseUrl}deviation-approval`,
  deviationRejectManager: `${apiBaseUrl}deviation-rejected`,
  getEditManagerPlanDevApprove: (id) => `${apiBaseUrl}deviation-details/${id}`,

  ifoodsPlanDevData: `${apiBaseUrl}plan-deviation-back-office-list`,
  getEditBoPlanDevApprove: (id) => `${apiBaseUrl}back-office-deviation-list/${id}`,
  ifoodsPlanDevApprove: `${apiBaseUrl}deviation-approval-back-office`,
  ifoodsPlanDevReject: `${apiBaseUrl}deviation-rejected-back-office`,

  planApplicable: `${apiBaseUrl}planappgroup-list`,
  planCategoryListByDivision: (id) => `${apiBaseUrl}plan-cat-type-by-division/${id}`,
  savePlanApplicable: `${apiBaseUrl}planappgroup-update`,
  updatePlanApplicable: `${apiBaseUrl}planappgroup-update`,
  deletePlanApplicable: (id) => `${apiBaseUrl}planappgroup-destroy/${id}`,
  getEditPlanApplicable: (id) => `${apiBaseUrl}planappgroup-show/${id}`,

  attendanceReport: `${apiBaseUrl}attendancepunch-report`,
  travelReport: `${apiBaseUrl}travel-details-report`,
  travelClaimReport: `${apiBaseUrl}get-travel-report`,
  // planReport: `${apiBaseUrl}plan-schedules-report`,
  planDetailsReport: `${apiBaseUrl}plan-details-log`,
  planDeviationReport: `${apiBaseUrl}plan-deviation-report`,
  planReport: `${apiBaseUrl}plan-report`,
  primaryOrderListReport: `${apiBaseUrl}primary-order-list`,
  primaryOrderDetails: (id) => `${apiBaseUrl}primary-customer-order-details/${id}`,
  appTrackReport: `${apiBaseUrl}app-track-logs-report`,
  marketPromotionReport: `${apiBaseUrl}market-promotions-report`,
  outletVisitReport: `${apiBaseUrl}outlet-visit-report`,
  productOfferReport: `${apiBaseUrl}competitor-product-offers-report`,
  competitorReport: `${apiBaseUrl}competitor-report`,
  expApplicableAmount: `${apiBaseUrl}expense-applicable-amount`,
  getSharingUserList: `${apiBaseUrl}expense-twin-sharing-user-list`,
  getAllowTravelKm: `${apiBaseUrl}get-travelled-distance-from-geo`,
  userMapReport: `${apiBaseUrl}get-user-google-map-report`,
  pjpReport: `${apiBaseUrl}foods-pjp-reports`,
  appTransportMode: (id) => `${apiBaseUrl}transport-mode-ddlist/${id}`,


  glMaster: `${apiBaseUrl}glaccouts-list`,
  saveGlMaster: `${apiBaseUrl}glaccouts-store`,
  updateGlMaster: `${apiBaseUrl}glaccouts-update`,
  deleteGlMaster: (id) => `${apiBaseUrl}glaccouts-destroy/${id}`,
  getEditGlMaster: (id) => `${apiBaseUrl}glaccouts-show/${id}`,

  foodsCompetitorMaster: `${apiBaseUrl}foods-competitor-list`,
  saveFoodsCompetitorMaster: `${apiBaseUrl}foods-competitor-store`,
  updateFoodsCompetitorMaster: `${apiBaseUrl}foods-competitor-update`,
  deleteFoodsCompetitorMaster: (id) => `${apiBaseUrl}foods-competitor-destroy/${id}`,
  getEditFoodsCompetitorMaster: (id) => `${apiBaseUrl}foods-competitor-show/${id}`,

  notificationSettingsList: `${apiBaseUrl}notification-setting-list`,
  saveNotificationSettingsList: `${apiBaseUrl}notification-setting-store`,
  deleteNotificationSettingsList: (id) => `${apiBaseUrl}notification-setting-destroy/${id}`,
  updateNotificationSettingsList: (id) => `${apiBaseUrl}notification-setting-update/${id}`,

  commonNotificationList: `${apiBaseUrl}common-notification-list`,
  saveCommonNotificationList: `${apiBaseUrl}common-notification-store`,
  deleteCommonNotificationList: (id) => `${apiBaseUrl}common-notification-destroy/${id}`,
  updateCommonNotificationList: (id) => `${apiBaseUrl}common-notification-update/${id}`,

  getPrimaryOrderCount: `${apiBaseUrl}get-primary-ordercount`,
  getWebNotificationCount: `${apiBaseUrl}get-web-notification`,
  primeCustMappingData: `${apiBaseUrl}fd-material-mapping-list`,
  fetchPrimeCustMappingData: (customer) =>
    `${apiBaseUrl}sap-foods-material-mapping/${customer}`,

  secondaryCustomerList: `${apiBaseUrl}secondarycustomer-backoffice-list`,
  secondaryCustomerSinApprove: `${apiBaseUrl}secondarycustomer-single-approval`,
  secondaryCustomerMulApprove: `${apiBaseUrl}secondarycustomer-multi-approval`,
  secondaryByDistrict: `${apiBaseUrl}secondary-by-district`,
  getEditSecondaryCustomer: (id) => `${apiBaseUrl}foods-secondarycustomer-show/${id}`,

  claimLocationCategory: `${apiBaseUrl}claimlocationcategory-list`,
  saveClaimLocationCategory: `${apiBaseUrl}claimlocationcategory-store`,
  updateClaimLocationCategory: `${apiBaseUrl}claimlocationcategory-update`,
  deleteClaimLocationCategory: (id) => `${apiBaseUrl}claimlocationcategory-destroy/${id}`,
  getEditClaimLocationCategory: (id) => `${apiBaseUrl}claimlocationcategory-show/${id}`,

  claimFrequencyList: `${apiBaseUrl}claimfrequency-list`,
  saveClaimFrequency: `${apiBaseUrl}claimfrequency-store`,
  updateClaimFrequency: `${apiBaseUrl}claimfrequency-update`,
  deleteClaimFrequency: (id) => `${apiBaseUrl}claimfrequency-destroy/${id}`,
  getEditClaimFrequency: (id) => `${apiBaseUrl}claimfrequency-show/${id}`,

  expenselimitMaster: `${apiBaseUrl}expense-limit-list`,
  saveExpenseLimitMaster: `${apiBaseUrl}expense-limit-store`,
  updateExpenseLimitMaster: `${apiBaseUrl}expense-limit-update`,
  deleteExpenseLimitMaster: (id) => `${apiBaseUrl}expense-limit-destroy/${id}`,
  getEditExpenseLimitMaster: (id) => `${apiBaseUrl}expense-limit-show/${id}`,

  frequencyTypeMaster: `${apiBaseUrl}claim-frequency-type-list`,
  saveFrequencyTypeMaster: `${apiBaseUrl}claim-frequency-type-store`,
  updateFrequencyTypeMaster: `${apiBaseUrl}claim-frequency-type-update`,
  deleteFrequencyTypeMaster: (id) => `${apiBaseUrl}claim-frequency-type-destroy/${id}`,
  getEditFrequencyTypeMaster: (id) => `${apiBaseUrl}claim-frequency-type-show/${id}`,

  targetFileUpload: `${apiBaseUrl}sales-target-upload`,
  claimStatusLog: `${apiBaseUrl}claim-status-log`,
  claimExpenseLog: `${apiBaseUrl}claim-expense-log`,
  claimLog: `${apiBaseUrl}claim-log`,

  dashboardSlider: `${apiBaseUrl}dashboard-slider-list`,
  saveDashboardSlider: `${apiBaseUrl}dashboard-slider-store`,
  updateDashboardSlider: `${apiBaseUrl}dashboard-slider-update`,
  deleteDashboardSlider: (id) => `${apiBaseUrl}dashboard-slider-destroy/${id}`,
  getEditDashboardSlider: (id) => `${apiBaseUrl}dashboard-slider-show/${id}`,

  //==================Sooji QR Bag =======================================//
  newBagRequest: `${apiBaseUrl}new-bag-list`,
  saveNewBagRequest: `${apiBaseUrl}new-bag-store`,
  updateNewBagRequest: `${apiBaseUrl}new-bag-update`,
  deleteNewBagRequest: (id) => `${apiBaseUrl}new-bag-destroy/${id}`,
  getEditNewBagRequest: (id) => `${apiBaseUrl}new-bag-show/${id}`,

  bagRequest: `${apiBaseUrl}bag-list`,
  saveBagRequest: `${apiBaseUrl}bag-store`,
  updateBagRequest: `${apiBaseUrl}bag-update`,
  deleteBagRequest: (id) => `${apiBaseUrl}bag-destroy/${id}`,
  getEditBagRequest: (id) => `${apiBaseUrl}bag-show/${id}`,

  bagIssue: `${apiBaseUrl}bag-issue-list`,
  saveBagIssue: `${apiBaseUrl}bag-issue-store`,
  updateBagIssue: `${apiBaseUrl}bag-issue-update`,
  deleteBagIssue: (id) => `${apiBaseUrl}bag-issue-destroy/${id}`,
  getEditBagIssue: (id) => `${apiBaseUrl}bag-issue-show/${id}`,


  storeNewBagRequest: `${apiBaseUrl}qr-code-create-bag-list`,
  saveStoreNewBagRequest: `${apiBaseUrl}qr-code-create-bag-store`,
  updateStoreNewBagRequest: `${apiBaseUrl}qr-code-create-bag-update`,
  deleteStoreNewBagRequest: (id) => `${apiBaseUrl}qr-code-create-bag-destroy/${id}`,
  getEditStoreNewBagRequest: (id) => `${apiBaseUrl}qr-code-create-bag-show/${id}`,

  bagReport: `${apiBaseUrl}bag-report-list`,
  saveBagReport: `${apiBaseUrl}bag-report-store`,
  updateBagReport: `${apiBaseUrl}bag-report-update`,
  deleteBagReport: (id) => `${apiBaseUrl}bag-report-destroy/${id}`,
  getEditBagReport: (id) => `${apiBaseUrl}bag-report-show/${id}`,

  fillBag: `${apiBaseUrl}fill-bag-list`,
  saveFillBag: `${apiBaseUrl}fill-bag-store`,
  updateFillBag: `${apiBaseUrl}fill-bag-update`,
  deleteFillBag: (id) => `${apiBaseUrl}fill-bag-destroy/${id}`,
  getEditFillBag: (id) => `${apiBaseUrl}fill-bag-show/${id}`,
  scrapFillBag: `${apiBaseUrl}fill-bag-scrap`,

  qcRelease: `${apiBaseUrl}qc-release-list`,
  qcReleaseExceeded: `${apiBaseUrl}qc-release-exceeded-list`,
  saveQCRelease: `${apiBaseUrl}qc-release-store`,
  updateQCRelease: `${apiBaseUrl}qc-release-update`,
  updateQCReleaseExceeded: `${apiBaseUrl}qc-release-exceeded-update`,
  deleteQCRelease: (id) => `${apiBaseUrl}qc-release-destroy/${id}`,
  getEditQCRelease: (id) => `${apiBaseUrl}qc-release-show/${id}`,
  getQRCodeDetails: (qrCode) => `/api/get-qr-code-details?qrCode=${encodeURIComponent(qrCode)}`,

  roastingProcess: `${apiBaseUrl}roasting-process-list`,
  roastingProcessExceeded: `${apiBaseUrl}roasting-release-exceeded-list`,
  saveRoastingProcess: `${apiBaseUrl}roasting-process-store`,
  updateRoastingProcess: `${apiBaseUrl}roasting-process-update`,
  updateRoastingProcessExceeded: `${apiBaseUrl}roasting-release-exceeded-update`,
  deleteRoastingProcess: (id) => `${apiBaseUrl}roasting-process-destroy/${id}`,
  getEditRoastingProcess: (id) => `${apiBaseUrl}roasting-process-show/${id}`,

  fumigationProcess: `${apiBaseUrl}fumigation-process-list`,
  fumigationProcessExceeded: `${apiBaseUrl}fumigation-release-exceeded-list`,
  saveFumigationProcess: `${apiBaseUrl}fumigation-process-store`,
  updateFumigationProcess: `${apiBaseUrl}fumigation-process-update`,
  updateFumigationProcessExceeded: `${apiBaseUrl}fumigation-release-exceeded-update`,
  deleteFumigationProcess: (id) => `${apiBaseUrl}fumigation-process-destroy/${id}`,
  getEditFumigationProcess: (id) => `${apiBaseUrl}fumigation-process-show/${id}`,

  qrTransReport: `${apiBaseUrl}qr-trans-report-list`,
  saveQRTransReport: `${apiBaseUrl}qr-trans-report-store`,
  updateQRTransReport: `${apiBaseUrl}qr-trans-report-update`,
  deleteQRTransReport: (id) => `${apiBaseUrl}qr-trans-report-destroy/${id}`,
  getEditQRTransReport: (id) => `${apiBaseUrl}qr-trans-report-show/${id}`,

  /* Foods Scheme */

  schemeCreation: `${apiBaseUrl}scheme-creation-list`,
  schemeCreationShow: 'scheme-creation-show',
  schemeCustomerRejectedLogs: 'scheme-customer-rejected-logs',
  saveSchemeCreation: `${apiBaseUrl}scheme-creation-store`,
  updateSchemeCreation: `${apiBaseUrl}scheme-creation-update`,
  deleteSchemeCreation: (id) => `${apiBaseUrl}scheme-creation-destroy/${id}`,
  getEditSchemeCreation: (id) => `${apiBaseUrl}scheme-creation-show/${id}`,

  schemeCreationApproval: `${apiBaseUrl}scheme-creation-approval-list`,
  saveSchemeCreationApproval: `${apiBaseUrl}scheme-creation-approval-store`,
  updateSchemeCreationApproval: `${apiBaseUrl}scheme-creation-approval-update`,
  deleteSchemeCreationApproval: (id) => `${apiBaseUrl}scheme-creation-approval-destroy/${id}`,
  getEditSchemeCreationApproval: (id) => `${apiBaseUrl}scheme-creation-approval-show/${id}`,
  getSchemeCreationApproved: `${apiBaseUrl}scheme-creation-approved-list`,

  schemeCreationApprovalCH: `${apiBaseUrl}scheme-creation-approval-ch-list`,
  saveSchemeCreationApprovalCH: `${apiBaseUrl}scheme-creation-approval-ch-store`,
  updateSchemeCreationApprovalCH: `${apiBaseUrl}scheme-creation-approval-ch-update`,
  deleteSchemeCreationApprovalCH: (id) => `${apiBaseUrl}scheme-creation-approval-ch-destroy/${id}`,
  getEditSchemeCreationApprovalCH: (id) => `${apiBaseUrl}scheme-creation-approval-ch-show/${id}`,
  getSchemeCreationApprovedCH: `${apiBaseUrl}scheme-creation-approved-ch-list`,

  schemeCreationApprovalBH: `${apiBaseUrl}scheme-creation-approval-bh-list`,
  saveSchemeCreationApprovalBH: `${apiBaseUrl}scheme-creation-approval-bh-store`,
  updateSchemeCreationApprovalBH: `${apiBaseUrl}scheme-creation-approval-bh-update`,
  deleteSchemeCreationApprovalBH: (id) => `${apiBaseUrl}scheme-creation-approval-bh-destroy/${id}`,
  getEditSchemeCreationApprovalBH: (id) => `${apiBaseUrl}scheme-creation-approval-bh-show/${id}`,
  getSchemeCreationApprovedBH: `${apiBaseUrl}scheme-creation-approved-bh-list`,


  /* Schemes List View */
  schemesListMaster: `${apiBaseUrl}scheme-list-details`,
  deleteSchemesListMaster: (id) => `${apiBaseUrl}scheme-list-destroy/${id}`,
  getEditSchemesListMaster: (id) => `${apiBaseUrl}scheme-list-show/${id}`,
  updateSchemesListMaster: `${apiBaseUrl}scheme-list-update`,
  rejectSchemesListMaster: `${apiBaseUrl}scheme-list-reject`,
  schemesListMasterAll: `${apiBaseUrl}scheme-list-details-all`,
  getEditSchemesListMasterAll: (id) => `${apiBaseUrl}scheme-list-show-all/${id}`,

  schemesListTeamWiseMaster: `${apiBaseUrl}scheme-list-teamwise-details`,
  getEditSchemesListTeamWiseMaster: (id) => `${apiBaseUrl}scheme-list-teamwise-show/${id}`,

  /* Schemes Non Eligible List View */
  schemesNonEligibleListMaster: `${apiBaseUrl}scheme-non-eligible-list-details`,
  getEditSchemesNonEligibleListMaster: (id) => `${apiBaseUrl}scheme-non-eligible-list-show/${id}`,
  updateSchemesNonEligibleListMaster: `${apiBaseUrl}scheme-non-eligible-list-update`,

  /* Foods Scheme */

  schemeMaster: `${apiBaseUrl}foods-scheme-list`,
  saveSchemeMaster: `${apiBaseUrl}foods-scheme-store`,
  updateSchemeMaster: `${apiBaseUrl}foods-scheme-update`,
  schemeDashboard: `${apiBaseUrl}foods-scheme-update`,
  deleteSchemeMaster: (id) => `${apiBaseUrl}foods-scheme-destroy/${id}`,
  getEditSchemeMaster: (id) => `${apiBaseUrl}foods-scheme-show/${id}`,
  getSchemeByGroupId: (id) => `${apiBaseUrl}foods-scheme-show-by-group-id/${id}`,

  schemeGMApproval: `${apiBaseUrl}scheme-gm-approval-list`,
  saveSchemeGMapproval: `${apiBaseUrl}scheme-gm-approval-store`,
  rejectSchemeGMapprovalMaster: `${apiBaseUrl}scheme-gm-reject-store`,
  updateSchemeGMapproval: `${apiBaseUrl}scheme-gm-approval-update`,
  deleteSchemeGMapproval: (id) => `${apiBaseUrl}scheme-gm-approval-destroy/${id}`,
  getEditSchemeGMApproval: (id) => `${apiBaseUrl}scheme-gm-approval-show/${id}`,
  getSchemeGMapproved: `${apiBaseUrl}scheme-gm-approved-list`,
  rejectSchemeGMapproval: `${apiBaseUrl}scheme-gm-reject`,
  individualRejectSchemeGMapproval: `${apiBaseUrl}scheme-gm-individual-reject`,
  schemeGMRejected: `${apiBaseUrl}scheme-gm-rejected-list`,

  schemeCHapproval: `${apiBaseUrl}scheme-ch-approval-list`,
  saveSchemeCHapproval: `${apiBaseUrl}scheme-ch-approval-store`,
  updateSchemeCHapproval: `${apiBaseUrl}scheme-ch-approval-update`,
  deleteSchemeCHapproval: (id) => `${apiBaseUrl}scheme-ch-approval-destroy/${id}`,
  getEditSchemeCHapproval: (id) => `${apiBaseUrl}scheme-ch-approval-show/${id}`,
  getSchemeCHapproved: `${apiBaseUrl}scheme-ch-approved-list`,
  rejectSchemeCHapproval: `${apiBaseUrl}scheme-ch-reject`,
  rejectSchemeCHapprovalMaster: `${apiBaseUrl}scheme-ch-reject-store`,
  individualRejectSchemeCHapproval: `${apiBaseUrl}scheme-ch-individual-reject`,
  schemeCHRejected: `${apiBaseUrl}scheme-ch-rejected-list`,
  schemeRejectedCustomersList: `${apiBaseUrl}scheme-rejected-customers-list`,
  schemeRejectedCustomersDetail: (id) => `${apiBaseUrl}scheme-rejected-customers-detailed-list/${id}`,
  resubmitRejectedCustomer: `${apiBaseUrl}rejected-customer-resubmit`,
  getClaimEmployeeExpenses: `${apiBaseUrl}claim-details-with-employee-expenses`,
  approvalDesignation: `${apiBaseUrl}status-designation`,


  schemeAdminEdit: `${apiBaseUrl}scheme-admin-edit-list`,
  saveSchemeAdminEdit: `${apiBaseUrl}scheme-admin-edit-store`,
  updateSchemeAdminEdit: `${apiBaseUrl}scheme-admin-edit-update`,
  deleteSchemeAdminEdit: (id) => `${apiBaseUrl}scheme-admin-edit-destroy/${id}`,
  getEditSchemeAdminEdit: (id) => `${apiBaseUrl}scheme-admin-edit-show/${id}`,
  getSchemeAdminEditApproved: `${apiBaseUrl}scheme-admin-edit-approved-list`,
  rejectSchemeAdminEdit: `${apiBaseUrl}scheme-admin-edit-reject`,

  schemeBHapproval: `${apiBaseUrl}scheme-bh-approval-list`,
  saveSchemeBHapproval: `${apiBaseUrl}scheme-bh-approval-store`,
  updateSchemeBHapproval: `${apiBaseUrl}scheme-bh-approval-update`,
  deleteSchemeBHapproval: (id) => `${apiBaseUrl}scheme-bh-approval-destroy/${id}`,
  getEditSchemeBHapproval: (id) => `${apiBaseUrl}scheme-bh-approval-show/${id}`,
  getSchemeBHapproved: `${apiBaseUrl}scheme-bh-approved-list`,
  rejectSchemeBHapproval: `${apiBaseUrl}scheme-bh-reject`,
  rejectSchemeBHapprovalMaster: `${apiBaseUrl}scheme-bh-reject-store`,
  individualRejectSchemeBHapproval: `${apiBaseUrl}scheme-bh-individual-reject`,
  schemeBHRejected: `${apiBaseUrl}scheme-bh-rejected-list`,

  schemeAHcreditnoteApproval: `${apiBaseUrl}scheme-ah-credit-note-approval-list`,
  saveSchemeAHCreditNoteApproval: `${apiBaseUrl}scheme-ah-credit-note-approval-update`,
  deleteSchemeAHCreditNoteApproval: (id) =>
    `${apiBaseUrl}scheme-ah-credit-note-approval-destroy/${id}`,
  getEditSchemeAHcreditnoteApproval: (id) =>
    `${apiBaseUrl}scheme-ah-credit-note-approval-show/${id}`,
  getSchemeAHCreditNoteApproved: `${apiBaseUrl}scheme-ah-credit-note-approved-list`,
  rejectSchemeAHCreditNoteApproval: `${apiBaseUrl}scheme-ah-credit-note-reject`,
  rejectSchemeAHApprovalMaster: `${apiBaseUrl}scheme-ah-credit-note-reject-store`,
  individualRejectSchemeAHApproval: `${apiBaseUrl}scheme-ah-individual-reject`,

  schemeCreditnoteReport: `${apiBaseUrl}scheme-credit-note-report-list`,
  getEditSchemeCreditnoteReport: (id) => `${apiBaseUrl}scheme-credit-note-report-show/${id}`,
  getCreditNotePdf: `${apiBaseUrl}get-credit-note-pdf`,

  schemeCostCenterMaster: `${apiBaseUrl}scheme-cost-center-list`,
  saveSchemeCostCenterMaster: `${apiBaseUrl}scheme-cost-center-master-store`,
  updateSchemeCostCenterMaster: (id) => `${apiBaseUrl}scheme-cost-center-master-update/${id}`,

  schemeProductCostCenterMapping: `${apiBaseUrl}scheme-product-cost-center-mapping-list`,
  saveSchemeProductCostCenterMapping: `${apiBaseUrl}scheme-product-cost-center-mapping-store`,
  updateSchemeProductCostCenterMapping: (id) => `${apiBaseUrl}scheme-product-cost-center-mapping-update/${id}`,
  schemeSapSync: `${apiBaseUrl}scheme-sap-credit-note-sync`,
  schemeCostCenterActualReport: `${apiBaseUrl}scheme-cost-center-actual-report`,
  schemeRejectedCustomerReport: `${apiBaseUrl}scheme-rejected-customer-report`,
  schemeRejectedCustomerLogs: (id) => `${apiBaseUrl}scheme-rejected-customer-logs/${id}`,

  /* Pest Control API */
  pestControlDailyEntryList: `${apiBaseUrl}pest-control-daily-entry-list`,
  savePestControlDailyEntry: `${apiBaseUrl}pest-control-daily-entry-store`,
  getPestControlDailyEntry: (id) => `${apiBaseUrl}pest-control-daily-entry-show/${id}`,
  deletePestControlDailyEntry: (id) => `${apiBaseUrl}pest-control-daily-entry-destroy/${id}`,

  /* Rodent Box Location Master */
  rodentBoxLocationMaster: `${apiBaseUrl}rodent-box-location-list`,
  saveRodentBoxLocationMaster: `${apiBaseUrl}rodent-box-location-store`,
  getRodentBoxLocationMaster: (id) => `${apiBaseUrl}rodent-box-location-show/${id}`,
  updateRodentBoxLocationMaster: `${apiBaseUrl}rodent-box-location-update`,
  deleteRodentBoxLocationMaster: (id) => `${apiBaseUrl}rodent-box-location-destroy/${id}`,

  /* Location Trap Station Mapping */
  locationTrapStationMapping: `${apiBaseUrl}location-trap-station-mapping-list`,
  locationTrapStationMappedNumbers: `${apiBaseUrl}location-trap-station-mapped-numbers`,
  saveLocationTrapStationMapping: `${apiBaseUrl}location-trap-station-mapping-store`,
  getLocationTrapStationMapping: (id) => `${apiBaseUrl}location-trap-station-mapping-show/${id}`,
  updateLocationTrapStationMapping: `${apiBaseUrl}location-trap-station-mapping-update`,
  deleteLocationTrapStationMapping: (id) => `${apiBaseUrl}location-trap-station-mapping-destroy/${id}`,

  /* Rodent QR Code Mapping */
  rodentQRCodeMapping: `${apiBaseUrl}rodent-qr-code-mapping-list`,
  rodentQRCodeAvailableMappings: `${apiBaseUrl}rodent-qr-code-available-mappings`,
  rodentQRCodeAvailableQRCodes: `${apiBaseUrl}rodent-qr-code-available-qrcodes`,
  saveRodentQRCodeMapping: `${apiBaseUrl}rodent-qr-code-mapping-store`,
  getRodentQRCodeMapping: (id) => `${apiBaseUrl}rodent-qr-code-mapping-show/${id}`,
  updateRodentQRCodeMapping: `${apiBaseUrl}rodent-qr-code-mapping-update`,
  deleteRodentQRCodeMapping: (id) => `${apiBaseUrl}rodent-qr-code-mapping-destroy/${id}`,

  /* Rodent QR Code Master */
  rodentQRCode: `${apiBaseUrl}rodent-qr-code-list`,
  rodentQRCodeNextNumber: `${apiBaseUrl}rodent-qr-code-next-number`,
  saveRodentQRCode: `${apiBaseUrl}rodent-qr-code-store`,
  batchSaveRodentQRCode: `${apiBaseUrl}rodent-qr-code-batch-store`,
  validateScannedRodentQRCode: `${apiBaseUrl}rodent-qr-code-validate-scanned`,
  getRodentQRCode: (id) => `${apiBaseUrl}rodent-qr-code-show/${id}`,
  updateRodentQRCode: `${apiBaseUrl}rodent-qr-code-update`,
  deleteRodentQRCode: (id) => `${apiBaseUrl}rodent-qr-code-destroy/${id}`,
});

